(() => {
  const scope =
    document.querySelector('[class*="ss_header_17"]') ||
    document.querySelector('[class*="ss_header"]');

  if (!scope) return;

  const CLOSE_DELAY = 450;
  let closeTimer = null;
  let openedLi = null;

  function getMenuLiFromTarget(target) {
    if (!target) return null;

    // Si on est sur un lien de menu ou dans sa zone
    const link = target.closest('[class*="header-menu-link-sections"], [class*="header-menu-item-sections"], [class*="header-menu-item-main-sections"]');
    if (!link) return null;

    const li = link.closest('li');
    if (!li) return null;

    // Ne gère que les li qui ont un submenu
    const submenu = li.querySelector('[class*="header-submenu-sections"]');
    if (!submenu) return null;

    return li;
  }

  function open(li) {
    if (!li) return;
    if (closeTimer) clearTimeout(closeTimer);

    if (openedLi && openedLi !== li) {
      openedLi.classList.remove('ss17-open');
    }

    li.classList.add('ss17-open');
    openedLi = li;
  }

  function closeLater() {
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      if (openedLi) openedLi.classList.remove('ss17-open');
      openedLi = null;
    }, CLOSE_DELAY);
  }

  // Ouvre quand on entre dans un item menu
  scope.addEventListener('mousemove', (e) => {
    const li = getMenuLiFromTarget(e.target);
    if (li) open(li);
  });

  // Garde ouvert quand on est dans le submenu
  scope.addEventListener('mouseenter', (e) => {
    const li = getMenuLiFromTarget(e.target);
    if (li) open(li);
  }, true);

  // Ferme avec délai quand on quitte la zone header
  scope.addEventListener('mouseleave', closeLater);

  // Ferme avec délai si on sort du li/submenu
  scope.addEventListener('mouseout', (e) => {
    // Si on sort complètement du header, on laissera mouseleave gérer
    // Sinon on schedule une fermeture douce
    closeLater();
  });

  window.__ss17HoverFix = true;
})();
